/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ChatMessageDto { 
    id?: string;
    seq?: number;
    role?: ChatMessageDto.RoleEnum;
    content?: string;
    uiBlockJson?: string;
    sourcesJson?: string;
    contextJson?: string;
    status?: ChatMessageDto.StatusEnum;
    createdAt?: Date;
    feedbackRating?: number;
}
export namespace ChatMessageDto {
    export type RoleEnum = 'USER' | 'ASSISTANT' | 'SYSTEM_EVENT';
    export const RoleEnum = {
        USER: 'USER' as RoleEnum,
        ASSISTANT: 'ASSISTANT' as RoleEnum,
        SYSTEMEVENT: 'SYSTEM_EVENT' as RoleEnum
    };
    export type StatusEnum = 'STREAMING' | 'COMPLETE' | 'ABORTED' | 'FAILED' | 'SUPERSEDED';
    export const StatusEnum = {
        STREAMING: 'STREAMING' as StatusEnum,
        COMPLETE: 'COMPLETE' as StatusEnum,
        ABORTED: 'ABORTED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        SUPERSEDED: 'SUPERSEDED' as StatusEnum
    };
}